module.exports = __webpack_public_path__ + "img/home-about-img2.1343b24c.png";